import _ from 'lodash'

class OverlayService {
  constructor () {
    this.callbackMap = {}
  }

  setEvent (event) {
    _.each(this.callbackMap.event, callback => {
      callback(event)
    })
  }

  startLoading () {
    const isLoading = true
    _.each(this.callbackMap.loading, callback => {
      callback(isLoading)
    })
  }

  stopLoading () {
    const isLoading = false
    _.each(this.callbackMap.loading, callback => {
      callback(isLoading)
    })
  }

  subscrib (type, callback) {
    this.callbackMap[type] = this.callbackMap[type] || []
    this.callbackMap[type].push(callback)
  }
}

export default new OverlayService()
